import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { AgreementResponse } from '../../responses/platform/agreement.response';

@Injectable({
  providedIn: 'root',
})
export class AgreementService extends CommonService {
  constructor(private httpClient: HttpClient) {
    super();
  }

  public getByStatusVersion(idStatusVersion: number): Observable<AgreementResponse> {
    const url: string = `${environment.urlApiPlatform}Agreement/idStatusVersion/${idStatusVersion}`;
    return this.httpClient
      .get<AgreementResponse>(url)
      .pipe(catchError(this.handleError));
  }
}
